<template>
    <!-- Bootstrap modal markup -->
    <div class="alert-modal fade" id="alertModal" tabindex="-1" aria-hidden="false" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body mb-4 mt-3 text-center">
                    <span class="material-symbols-outlined mb-2" :class="icon_color" style="font-size: 2.5rem;">{{ icon }}</span>
                    <h4>{{ title }}</h4>
                    <p class="text-sm text-muted mt-3">{{ detail }}</p>
                    <button v-if="!prompt" class="btn btn-secondary btn-rounded px-5 text-sm" @click="respond(true)" data-dismiss="modal">OK</button>
                    <button v-if="prompt" class="btn btn-secondary btn-rounded px-4 text-sm mr-2" @click="respond(true)" data-dismiss="modal">Oui</button>
                    <button v-if="prompt" class="btn btn-danger btn-rounded px-4 text-sm" @click="respond(false)" data-dismiss="modal">Retour</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.modal-open .alert-modal {
    overflow-x: hidden;
    overflow-y: auto
}

.alert-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0
}
.alert-modal, .alert-modal .modal-dialog, .alert-modal .modal-content { pointer-events: auto }
.alert-modal.fade .modal-dialog {
    transition: -webkit-transform .3s ease-out;
    transition: transform .3s ease-out;
    transition: transform .3s ease-out, -webkit-transform .3s ease-out;
    -webkit-transform: translate(0, -50px);
    transform: translate(0, -50px)
}

@media (prefers-reduced-motion:reduce) {
    .alert-modal.fade .modal-dialog {
        transition: none
    }
}

.alert-modal.show .modal-dialog {
    -webkit-transform: none;
    transform: none
}

.alert-modal.modal-static .modal-dialog {
    -webkit-transform: scale(1.02);
    transform: scale(1.02)
}
</style>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: {
        ...mapState('modal', ['show', 'stacked', 'icon', 'icon_color', 'title', 'detail', 'prompt', 'resolve'] ),
    },
    methods: {
        ...mapActions('modal', ['respond'])
    },
    mounted() {
        this.$store.dispatch('modal/closeModal')
        $('#alertModal').on('hidden.bs.modal', () => {
            $('.modal-backdrop').remove()
            this.$store.dispatch('modal/closeModal')
            const openedModals = $('.modal.show').length
            if (openedModals > 0) {
                $('body').addClass('modal-open')
                const $prev = $('.modal.show').last()
                try { $prev.trigger('focus') } catch (e) {}
            } else {
                $('body').removeClass('modal-open')
            }
        })
        $('#alertModal').on('shown.bs.modal', () => {
        })
    },
    watch: {
        // Watch Vuex state and trigger Bootstrap modal
        show(newVal, oldVal) {
            if (newVal) {
                // Show modal via Bootstrap JS
                $('.modal-backdrop').remove()
                $('#alertModal').modal('show')
                this.$nextTick(() => {
                    $('#alertModal').css('z-index', 20000)
                    $('.modal-backdrop').css('z-index', 19990)
                })
            } else {
                // Hide modal via Bootstrap JS
                $('#alertModal').modal('hide')
                $('.modal-backdrop').remove()
                const opened = $('.modal.show').length
                if (opened === 0) $('body').removeClass('modal-open')
            }
        }
    }
}
</script>